import { render, staticRenderFns } from "./phdetails.vue?vue&type=template&id=c3507014"
import script from "./phdetails.vue?vue&type=script&lang=js"
export * from "./phdetails.vue?vue&type=script&lang=js"
import style0 from "./phdetails.vue?vue&type=style&index=0&id=c3507014&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports